import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthContext } from '../../contexts/AuthContext'; // Usando o hook do seu contexto

interface Permissao {
  entidade: string;
  acao: string;
}

interface RotaProtegidaProps {
  /**
   * Lista de permissões necessárias para acessar a rota.
   * Ex: [{ entidade: 'cliente', acao: 'visualizar' }]
   */
  permissoesNecessarias: Permissao[];
  /**
   * Rota para a qual o usuário será redirecionado se não tiver permissão.
   * @default '/nao-autorizado'
   */
  redirectTo?: string;
}

const RotaProtegida: React.FC<RotaProtegidaProps> = ({ permissoesNecessarias, redirectTo = '/nao-autorizado' }) => {
  const { isAuthenticated, hasPermission, loading } = useAuthContext();

  // Se ainda estiver carregando a informação de auth, não renderiza nada (ou um spinner)
  if (loading) {
    return null; // Ou <Spinner />, <Loading />, etc.
  }

  // Se não estiver autenticado, redireciona para o login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Verifica se o usuário possui TODAS as permissões necessárias usando a função do contexto.
  // A lógica de Admin já está dentro de `hasPermission`.
  const temAcesso = permissoesNecessarias.every((p) => hasPermission(p)) ;

  if (!temAcesso) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
};

export default RotaProtegida;